import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-1 mb-4" aria-label={`${count} out of 5 stars`} data-id="element-202">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`w-5 h-5 ${i < count ? 'text-brand-orange fill-brand-orange' : 'text-brand-border'}`} aria-hidden="true" data-id="element-203" />)}
    </div>;
}
export function Reviews() {
  return <section id="reviews" className="w-full bg-brand-dark py-16 md:py-24 border-t border-brand-border" aria-labelledby="reviews-heading" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16" data-id="element-206">
          <h2 id="reviews-heading" className="font-oswald font-bold text-[28px] sm:text-3xl md:text-4xl lg:text-5xl uppercase tracking-wide text-white mb-4" data-id="element-207">
            What Our Customers Say
          </h2>
          <p className="text-brand-muted text-base md:text-lg max-w-2xl mx-auto" data-id="element-208">
            Don't take our word for it — hear from the contractors who trust
            PES.
          </p>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-209">
          {/* Review 1 — Dennis */}
          <div className="bg-brand-card rounded-lg p-8 border border-brand-border relative" data-id="element-210">
            <QuoteIcon className="w-10 h-10 text-brand-orange/30 absolute top-6 right-6" aria-hidden="true" data-id="element-211" />
            <StarRating count={5} data-id="element-212" />
            <blockquote className="text-white text-base leading-relaxed mb-6" data-id="element-213">
              "Bought a CAT 259D from Payne Equipment and the whole process was
              smooth. No pressure, fair price, and the machine was exactly as
              described. These guys are the real deal."
            </blockquote>
            <div className="flex items-center gap-3" data-id="element-214">
              <div className="w-10 h-10 rounded-full bg-brand-orange/20 flex items-center justify-center" data-id="element-215">
                <span className="font-oswald font-bold text-brand-orange text-sm" data-id="element-216">
                  D
                </span>
              </div>
              <div data-id="element-217">
                <p className="font-oswald font-semibold text-white text-sm" data-id="element-218">
                  Dennis
                </p>
                <p className="text-brand-muted text-xs" data-id="element-219">Verified Buyer</p>
              </div>
            </div>
          </div>

          {/* Review 2 — Rogelio */}
          <div className="bg-brand-card rounded-lg p-8 border border-brand-border relative" data-id="element-220">
            <QuoteIcon className="w-10 h-10 text-brand-orange/30 absolute top-6 right-6" aria-hidden="true" data-id="element-221" />
            <StarRating count={5} data-id="element-222" />
            <blockquote className="text-white text-base leading-relaxed mb-6" data-id="element-223">
              "I've purchased three machines from PES over the past two years.
              Every time, they go above and beyond. Financing was easy and the
              equipment runs great. Highly recommend."
            </blockquote>
            <div className="flex items-center gap-3" data-id="element-224">
              <div className="w-10 h-10 rounded-full bg-brand-orange/20 flex items-center justify-center" data-id="element-225">
                <span className="font-oswald font-bold text-brand-orange text-sm" data-id="element-226">
                  R
                </span>
              </div>
              <div data-id="element-227">
                <p className="font-oswald font-semibold text-white text-sm" data-id="element-228">
                  Rogelio
                </p>
                <p className="text-brand-muted text-xs" data-id="element-229">Verified Buyer</p>
              </div>
            </div>
          </div>

          {/* Review 3 — Tre & Landon */}
          <div className="bg-brand-card rounded-lg p-8 border border-brand-border relative" data-id="element-230">
            <QuoteIcon className="w-10 h-10 text-brand-orange/30 absolute top-6 right-6" aria-hidden="true" data-id="element-231" />
            <StarRating count={5} data-id="element-232" />
            <blockquote className="text-white text-base leading-relaxed mb-6" data-id="element-233">
              "Best equipment dealer in Arizona, hands down. Tre and Landon
              helped us find exactly what we needed for our landscaping
              business. Fair prices and honest people."
            </blockquote>
            <div className="flex items-center gap-3" data-id="element-234">
              <div className="w-10 h-10 rounded-full bg-brand-orange/20 flex items-center justify-center" data-id="element-235">
                <span className="font-oswald font-bold text-brand-orange text-sm" data-id="element-236">
                  T
                </span>
              </div>
              <div data-id="element-237">
                <p className="font-oswald font-semibold text-white text-sm" data-id="element-238">
                  Tre & Landon
                </p>
                <p className="text-brand-muted text-xs" data-id="element-239">Verified Buyers</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}